import type { LeadFormState } from '@core/Atoms/Pdp/FormState.atom';
import type { SearchParamsType } from '@core/Atoms/SearchParams/SearchParams.atom';
import type { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import type { TrackingDataType } from '@tracking/Entities/TrackingDataType.entity';
import { vehicleToListingEvent } from '@tracking/Schemas/Listing/VehicleToListingEvent';
import { vehicleToListingFeatureEvent } from '@tracking/Schemas/ListingFeature/VehicleToListingFeatureEvent';
import { marketingToEvent } from '@tracking/Schemas/Marketing/MarketingToEvent';
import { reservationStartToEvent } from '@tracking/Schemas/Reservation/ReservationStart/ReservationStartToEvent';
import { userContextToEvent } from '@tracking/Schemas/UserContext/UserContextToEvent';

interface Props {
  searchParams: SearchParamsType;
  userId: string | null | undefined;
  formState: LeadFormState;
  listingId: string | null;
  source?: string;
  vehicle: Vehicle;
}

export function generateReservationTrackingData({
  searchParams,
  userId,
  formState,
  listingId,
  vehicle,
}: Props): Record<string, TrackingDataType> {
  const marketingDataObj = {
    marketingValues: {
      ...searchParams,
    },
  };

  const userData = {
    userId,
    values: { ...formState },
  };
  const leadStartObj = {
    listingId,
    leadType: 'reserve',
  };

  // event actions
  const reserveStartEvent = reservationStartToEvent(leadStartObj);

  // event entities
  const userEvent = userContextToEvent(userData);
  const listingEvent = vehicleToListingEvent(vehicle);
  const marketingEvent = marketingToEvent(marketingDataObj);
  const listingFeatureEvent = vehicleToListingFeatureEvent(vehicle);

  const contextStart = [listingEvent, listingFeatureEvent, userEvent, marketingEvent];

  return {
    reserveStart: { event: reserveStartEvent, context: contextStart },
  };
}
